import { render, staticRenderFns } from "./Alojamientos.vue?vue&type=template&id=1ccdccd0"
import script from "./Alojamientos.vue?vue&type=script&lang=js"
export * from "./Alojamientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports